import * as React from 'react';
import { Link } from 'react-router-dom';
import { DateTime } from 'luxon';
import SearchIcon from './SvgSearch';
import Select from 'react-select';
import Tooltip from '../components/Tooltip';
import { formatDate } from './date';
import { Column } from 'react-table';

/* COMPONENTS */

export const TooltipHeader = props => (
  <Tooltip text={props.value} showOnlyOnOverflow={true}>
    <span>
      {props.value}
    </span>
  </Tooltip>
);

export const TooltipCell = props => (
  <Tooltip text={props.value} showOnlyOnOverflow={true}>
    <span>
      {props.value}
    </span>
  </Tooltip>
);

export const LinkedTooltipCell = (linker, isReporter) => props => {
  let styling;
  switch (props.value) {
    case 'grocer submitted':
      styling = 'submitted';
      break;
    case 'pending':
      styling = 'pending';
      break;
    case 'incomplete':
      styling = 'incomplete';
      break;
    case 'completed':
      styling = 'completed';
      break;
    case 'submitted for adjustment':
      styling = 'adjustment';
      break;
    case 'approved by admin':
      styling = 'approved';
      break;
    case 'NEW':
      styling = 'newNotif';
      break;
    default:
      styling = '';
      break;
  }

  const tooltip = (
    <Tooltip text={props.value} showOnlyOnOverflow={true}>
      <span className="box-container">
        {/* We need a span here for the tooltip to calculate the inner size */}
        <span className={styling}>
          {props.value}
        </span>
      </span>
    </Tooltip>
  );
  return (
    <Link to={linker(props)}>
      {tooltip}
    </Link >
  );
};

export const DateCell = (props) => {
  if (props.value instanceof DateTime) {
    return <TooltipCell value={props.value.toFormat('LLL dd yyyy')} />;
  } else {
    return <TooltipCell value={props.value} />;
  }
};
export const BooleanCell = (props) => (
  <TooltipCell value={props.value ? 'Yes' : 'No'} />
);

export const NotificationCell = (props) => (
  <TooltipCell value={props.value ? 'Yes' : '-'} />
);

export const LinkedDateCell = (linker) => (props) => (
  <Link to={linker(props)}>{DateCell(props)}</Link>
);

export const SearchFilter = ({ onChange, filter }) => (
  <div className="filter">
    <span className="filter-icon">
      <SearchIcon />
    </span>
    <input onChange={event => onChange(event.target.value)} value={filter ? filter.value : ''} />
  </div>
);

export const DropdownFilter = ({ onChange, filter, options }) => (
  <Select
    options={options}
    searchable={false}
    value={filter ? filter.value : ''}
    onChange={(value) => onChange(value)}
  />
);

/**
 * A component to be displayed when there is no data in the table.
 * Hides the "No Data" text while the table is loading.
 */
export const NoDataMessage = ({ isLoading }: { isLoading: boolean }) => {
  return isLoading ? null : <div className="rt-noData">No Data</div>;
};

/* ACCESSORS */

type Accessor = Pick<Column, 'accessor' | 'id'>;

function datePropertyAccessor(propertyName: string): Accessor {
  return {
    id: propertyName,
    accessor(row: object) {
      return formatDate(row[propertyName]);
    }
  };
}

function mappedPropertyAccessor<T, S>(propertyName: string, valueMap: ReadonlyMap<T, S>): Accessor {
  return {
    id: propertyName,
    accessor(row: object) {
      return valueMap.get(row[propertyName]);
    }
  };
}

function arrayAggregatorAccessor(propertyName: string, elementSeparator: string): Accessor {
  return {
    id: propertyName,
    accessor(row: object) {
      return row[propertyName].join(elementSeparator);
    }
  };
}

export { datePropertyAccessor, mappedPropertyAccessor, arrayAggregatorAccessor };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/helpers/Table.tsx